export default __webpack_public_path__ + "c781a72cc642067e16410f0ef179b923.svg";